export default __webpack_public_path__ + "static/media/load-card.7753c05e.svg";